<b-modal v-model="modal_requirement_072" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      <!-- 実行中 -->
      <template v-if="phase === 'inProgress'">
        {{ $t('individual.common_title_execution') }}
      </template>
      <!-- 引継ぎ結果表示画面 -->
      <template v-if="phase === 'result'">
        {{ $t('message.common_title_confirmation') }}
      </template>
      <!-- 引継ぎ失敗表示画面, 通信エラー画面, 引継ぎエラー要因表示 -->
      <template v-if="(phase === 'failed') || (phase === 'communicationError') 
      || (phase === 'errorFactor') || (phase === 'error')">
        {{ $t('message.common_title_error') }}
      </template>
    </div>
  </template>

  <template v-slot:default>
    <ShowLessBOverlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- 実行中 -->
        <template v-if="phase === 'inProgress'">
          <div class="w-100">
            <div class="box-margin-right work-support-message"
            style="white-space: break-spaces;">{{ $t('individual.label_in_progress_calibration') }}</div>
          </div>
        </template>
        <!-- 引継ぎ失敗表示画面 -->
        <template v-if="phase === 'failed'">
          <div class="w-100">
            <div class="box-margin-right work-support-message"
            style="white-space: break-spaces;">{{ $t('individual.label_failed_calibration') }}</div>
          </div>
        </template>
        <!-- 引継ぎ結果表示画面 エラー要因表示画面 -->
        <template v-if="(phase === 'result') || (phase === 'errorFactor')">
          <div class="w-100" v-if="phase === 'errorFactor'">
            <div class="box-margin-right work-support-message"
              style="white-space: break-spaces;" v-html="$t('individual.label_result_message_failed')"></div>
          </div>
          <div class="row no-gutters">
            <div class="w-100">
              <div style="max-height: 265px; overflow-y: auto;">
                <!-- テーブル部品 -->
                <cstm-table
                  id="cstm-table"
                  useStripeStyle
                  hasTabs
                  useSort
                  initSortDir="asc"
                  :items="bodyItems"
                  :columns="systemTableColumns"
                  type="simple"
                >
                </cstm-table>
              </div>
            </div>
          </div>
          <div class="w-100" v-if="(phase === 'result')">
            <div class="box-margin-right work-support-message"
            style="white-space: break-spaces;" v-html="$t('individual.label_result_message_success')"></div>
          </div>
        </template>
        <!-- 通信エラー画面 -->
        <template v-if="phase === 'communicationError'">
          <div class="w-100">
            <div class="box-margin-right work-support-message"
            style="white-space: break-spaces;">{{ $t('individual.label_communication_error') }}</div>
          </div>
        </template>
        <!-- エラー画面 -->
        <template v-if="phase === 'error'">
          <div class="w-100">
            <div class="box-margin-right work-support-message"
            style="white-space: break-spaces;">{{ $t('individual.error_communication_error') }}</div>
          </div>
        </template>
      </div>
    </ShowLessBOverlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- 引継ぎ失敗表示画面 -->
      <template v-if="phase === 'failed'">
        <b-button :disabled="isLoading" size="sm" variant="primary"
        @click="onFailedOkClicked" class="mx-2">{{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 引継ぎ結果表示画面 -->
      <template v-if="(phase === 'result')">
        <b-button :disabled="isLoading" size="sm" variant="primary"
        @click="onResultBackClicked" class="mx-2">{{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 引継ぎエラー要因表示画面 -->
      <template v-if="phase === 'errorFactor'">
        <b-button :disabled="isLoading" size="sm" variant="primary"
        @click="onResultBackClicked" class="mx-2">{{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 通信エラー画面 -->
      <template v-if="phase === 'communicationError'">
        <b-button :disabled="isLoading" size="sm" variant="primary"
        @click="onCommunicationErrorOkClicked" class="mx-2">{{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- エラー画面 -->
      <template v-if="phase === 'error'">
        <b-button :disabled="isLoading" size="sm" variant="primary"
        @click="onErrorOkClicked" class="mx-2">{{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>